module.exports = __webpack_public_path__ + "static/media/logo-countpicula-dark.d77f1dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo-countpicula-dark.png
// module id = 33
// module chunks = 0